import React from "react";
import { Drawer, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const UserAlertsDrawer = ({ open, onClose, trafficData }) => {
    const alerts = trafficData?.alertSummary?.types || [];

    const alertTypeMap = {
        checkout_frequency: "High Checkout Frequency",
        checkout_page_views_high: "High Checkout Page Views",
        single_page_high: "High Single Page Views",
    };

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            sx={{
                "& .MuiDrawer-paper": {
                    width: "450px",
                    top: "0px !important",
                    height: "100%",
                    p: 0,
                    backgroundColor: "#fafafa"
                }
            }}
        >
            <Box sx={{ p: 0 }}>
                <Box className="d-flex justify-content-between align-items-center px-3 py-3 bg-white" style={{ borderBottom: "1px solid #EEEEEE" }}>
                    <Box className="d-flex align-items-center gap-2">
                        <ErrorOutlineIcon style={{ color: "#FFD700" }} />
                        <Typography className="sofiaBold" style={{ fontSize: "18px", color: "#1D1D1B" }}>
                            Active Alerts
                        </Typography>
                    </Box>
                    <IconButton onClick={onClose} size="small" sx={{ backgroundColor: "#F5F5F5" }}>
                        <CloseIcon sx={{ fontSize: "18px" }} />
                    </IconButton>
                </Box>

                <Box sx={{ p: 3 }}>
                    <Box className="mb-4">
                        <Typography className="sofiaRegular" style={{ fontSize: "14px", color: "#666" }}>
                            Showing active alerts for IP:
                        </Typography>
                        <Typography className="sofiaBold" style={{ fontSize: "16px", color: "#1D1D1B" }}>
                            {trafficData?.ip}
                        </Typography>
                    </Box>

                    {alerts.length > 0 ? (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            {alerts.map((type, idx) => (
                                <Box
                                    key={idx}
                                    className="p-3 bg-white d-flex align-items-center gap-3"
                                    style={{
                                        borderRadius: "12px",
                                        border: "1px solid #EEEEEE",
                                        boxShadow: "0px 2px 4px rgba(0,0,0,0.02)"
                                    }}
                                >
                                    <Box
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "10px",
                                            backgroundColor: "#FFF9E6"
                                        }}
                                    >
                                        <ErrorOutlineIcon style={{ color: "#FFD700", fontSize: "20px" }} />
                                    </Box>
                                    <Box>
                                        <Typography className="sofiaBold" style={{ fontSize: "14px", color: "#1D1D1B" }}>
                                            {alertTypeMap[type] || type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                                        </Typography>
                                        <Typography className="sofiaRegular" style={{ fontSize: "12px", color: "#666" }}>
                                            This IP has triggered the {type.replace(/_/g, ' ')} condition.
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    ) : (
                        <Box className="text-center py-5">
                            <Typography className="sofiaBold" style={{ color: "#BBBBBB" }}>
                                No active alerts found for this IP.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Drawer>
    );
};

export default UserAlertsDrawer;
